export default "__VITE_ASSET__IFv6y$eS__"